// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import { axiosClient } from '../../utils/auth.util.js';
// import axios from 'axios';

// // Token management utilities for register system
// const saveRegisterTokenToLocalStorage = (token) => {
//   if (token) {
//     localStorage.setItem('registerToken', token);
//   }
// };

// const removeRegisterTokenFromLocalStorage = () => {
//   localStorage.removeItem('registerToken');
// };

// const getRegisterTokenFromLocalStorage = () => {
//   return localStorage.getItem('registerToken');
// };

// // Update axios client for register token
// const registerAxiosClient = axios.create({
//   ...axiosClient.defaults,
// });

// // Add interceptor for register token
// registerAxiosClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('registerToken');
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//       config.headers['x-auth-token'] = token;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Registration Status Constants (matching backend)
// export const REGISTRATION_STATUS = {
//   REJECTED: -1,
//   EMAIL_VERIFIED: 1,
//   PROFILE_COMPLETED: 2,
//   INTERVIEW_REQUESTED_OR_SCREENING_COMPLETED: 3,
//   APPROVED: 4
// };

// // Initial state
// const initialState = {
//   userData: null,
//   authToken: getRegisterTokenFromLocalStorage(),
//   submittedEmail: '',
//   isOtpSent: false,
//   registrationFlow: {
//     step: 'email_input',
//     userType: null,
//     email: '',
//     isOtpSent: false,
//     nextAction: null,
//   },
//   isLoggedIn: !!getRegisterTokenFromLocalStorage(),
//   isLoading: false,
//   error: null,
//   whatsappOtpSent: false,
//   whatsappVerified: false,
// };

// // Async thunks for Onboarding Process
// export const sendOnboardingOTP = createAsyncThunk(
//   'register/sendOnboardingOTP',
//   async (email, { rejectWithValue }) => {
//     try {
//       const response = await axiosClient.post('/pendingexpert/send-otp/pendingexpert', { email });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'Failed to send OTP' });
//     }
//   }
// );

// export const verifyOnboardingOTP = createAsyncThunk(
//   'register/verifyOnboardingOTP',
//   async ({ email, otp_entered }, { rejectWithValue }) => {
//     try {
//       const response = await axiosClient.post('/pendingexpert/login/pendingexpert', {
//         email,
//         otp_entered
//       });

//       if (response.data.result?.token) {
//         saveRegisterTokenToLocalStorage(response.data.result.token);
//       }

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'OTP verification failed' });
//     }
//   }
// );

// export const verifyUser = createAsyncThunk(
//   'register/verifyUser',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await registerAxiosClient.post('/pendingexpert/verify-user/pendingexpert');
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'User verification failed' });
//     }
//   }
// );

// export const updateUserProfile = createAsyncThunk(
//   'register/updateUserProfile',
//   async (profileData, { rejectWithValue }) => {
//     try {
//       const response = await registerAxiosClient.put('/pendingexpert/update-profile', profileData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'Profile update failed' });
//     }
//   }
// );

// export const scheduleInterview = createAsyncThunk(
//   'register/scheduleInterview',
//   async (interviewData, { rejectWithValue }) => {
//     try {
//       const response = await registerAxiosClient.post('/pendingexpert/schedule-meeting', interviewData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'Interview scheduling failed' });
//     }
//   }
// );

// // WhatsApp verification actions
// export const sendWhatsAppOTP = createAsyncThunk(
//   'register/sendWhatsAppOTP',
//   async ({ name, whatsappNumber }, { rejectWithValue, getState }) => {
//     try {
//       const state = getState();
//       const userId = state.register.userData?.email?.replace(/[@.]/g, '_') || `USER_${Date.now()}`;
      
//       const response = await axios.post(
//         'https://testapis4.el.r.appspot.com/api/tutorWeb/sendVerificationOtp',
//         {
//           name: name.trim(),
//           wa_id: whatsappNumber.trim(),
//           tutorId: userId,
//         },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           timeout: 10000,
//         }
//       );
      
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'Failed to send WhatsApp OTP' });
//     }
//   }
// );

// export const verifyWhatsAppOTP = createAsyncThunk(
//   'register/verifyWhatsAppOTP',
//   async ({ otp }, { rejectWithValue, getState }) => {
//     try {
//       const state = getState();
//       const userId = state.register.userData?.email?.replace(/[@.]/g, '_') || `USER_${Date.now()}`;
      
//       const response = await axios.post(
//         'https://testapis4.el.r.appspot.com/api/tutorWeb/verifyOtp',
//         {
//           tutorId: userId,
//           code: otp.trim(),
//         }
//       );
      
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || { message: 'WhatsApp OTP verification failed' });
//     }
//   }
// );

// // Helper functions
// const getRegistrationStatusText = (status, expertiseDomain) => {
//   const statusMap = {
//     [-1]: 'Rejected',
//     [1]: 'Email Verified',
//     [2]: 'Profile Completed',
//     [3]: expertiseDomain === 'Music Tutor' ? 'Interview Requested' : 'Screening Completed',
//     [4]: 'Approved'
//   };
//   return statusMap[status] || 'Unknown';
// };

// const isProfileCompleted = (status) => status >= REGISTRATION_STATUS.PROFILE_COMPLETED;
// const canProceedToNextStage = (status) => status > 0 && status < REGISTRATION_STATUS.APPROVED;
// const isApproved = (status) => status === REGISTRATION_STATUS.APPROVED;
// const isRejected = (status) => status === REGISTRATION_STATUS.REJECTED;

// // Redux slice
// const registerSlice = createSlice({
//   name: 'register',
//   initialState,
//   reducers: {
//     setRegistrationEmail: (state, action) => {
//       state.submittedEmail = action.payload;
//       state.registrationFlow.email = action.payload;
//     },
    
//     setRegistrationStep: (state, action) => {
//       state.registrationFlow.step = action.payload;
//     },
    
//     resetRegistrationFlow: (state) => {
//       state.submittedEmail = '';
//       state.isOtpSent = false;
//       state.registrationFlow = {
//         step: 'email_input',
//         userType: null,
//         email: '',
//         isOtpSent: false,
//         nextAction: null,
//       };
//       state.error = null;
//     },
    
//     logout: (state) => {
//       Object.assign(state, {
//         userData: null,
//         authToken: null,
//         submittedEmail: '',
//         isOtpSent: false,
//         registrationFlow: {
//           step: 'email_input',
//           userType: null,
//           email: '',
//           isOtpSent: false,
//           nextAction: null,
//         },
//         isLoggedIn: false,
//         error: null,
//       });
//       removeRegisterTokenFromLocalStorage();
//     },
    
//     clearError: (state) => {
//       state.error = null;
//     },

//     updateUserData: (state, action) => {
//       state.userData = { ...state.userData, ...action.payload };
//     },

//     setWhatsAppOtpSent: (state, action) => {
//       state.whatsappOtpSent = action.payload;
//     },

//     setWhatsAppVerified: (state, action) => {
//       state.whatsappVerified = action.payload;
//     },

//     clearWhatsAppStates: (state) => {
//       state.whatsappOtpSent = false;
//       state.whatsappVerified = false;
//     },
//   },
  
//   extraReducers: (builder) => {
//     // Send onboarding OTP
//     builder
//       .addCase(sendOnboardingOTP.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(sendOnboardingOTP.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isOtpSent = true;
//         state.registrationFlow.isOtpSent = true;
//         state.registrationFlow.step = 'otp_verification';
//       })
//       .addCase(sendOnboardingOTP.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'Failed to send OTP';
//       });

//     // Verify onboarding OTP
//     builder
//       .addCase(verifyOnboardingOTP.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(verifyOnboardingOTP.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isLoggedIn = true;
//         state.authToken = action.payload.token;
//         state.userData = action.payload.result;
//         state.registrationFlow.step = 'complete';
//       })
//       .addCase(verifyOnboardingOTP.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'OTP verification failed';
//       });

//     // Verify user
//     builder
//       .addCase(verifyUser.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(verifyUser.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.userData = action.payload.result?.expert;
//       })
//       .addCase(verifyUser.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'User verification failed';
        
//         if (action.payload?.message?.includes('token') || action.payload?.message?.includes('Unauthorized')) {
//           state.userData = null;
//           state.authToken = null;
//           state.isLoggedIn = false;
//           removeRegisterTokenFromLocalStorage();
//         }
//       });

//     // Update user profile
//     builder
//       .addCase(updateUserProfile.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(updateUserProfile.fulfilled, (state, action) => {
//         state.isLoading = false;
        
//         // Update userData with the complete response
//         const updatedData = action.payload.result;
//         state.userData = updatedData; // Store the complete updated expert data
        
//         // If WhatsApp verification was updated, update the whatsappVerified state
//         if (updatedData.whatsappNumber?.verified !== undefined) {
//           state.whatsappVerified = updatedData.whatsappNumber.verified;
//         }
        
//         console.log('Profile updated in Redux:', {
//           userData: state.userData,
//           registrationStatus: state.userData.registrationStatus,
//           whatsappVerified: state.whatsappVerified
//         });
//       })
//       .addCase(updateUserProfile.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'Profile update failed';
//       });

//     // Schedule interview
//     builder
//       .addCase(scheduleInterview.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(scheduleInterview.fulfilled, (state, action) => {
//         state.isLoading = false;
        
//         // Update userData with interview information from backend response
//         const result = action.payload.result;
//         if (result?.expert) {
//           state.userData = { 
//             ...state.userData, 
//             ...result.expert,
//             interviewScheduled: true,
//             interviewStatus: 'scheduled'
//           };
//         }
//       })
//       .addCase(scheduleInterview.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'Interview scheduling failed';
//       });

//     // Send WhatsApp OTP
//     builder
//       .addCase(sendWhatsAppOTP.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(sendWhatsAppOTP.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.whatsappOtpSent = true;
//       })
//       .addCase(sendWhatsAppOTP.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'Failed to send WhatsApp OTP';
//         state.whatsappOtpSent = false;
//       });

//     // Verify WhatsApp OTP
//     builder
//       .addCase(verifyWhatsAppOTP.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(verifyWhatsAppOTP.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.whatsappVerified = true;
//         state.whatsappOtpSent = false;
        
//         // Also update userData to reflect WhatsApp verification
//         if (state.userData) {
//           state.userData = {
//             ...state.userData,
//             whatsappNumber: {
//               ...state.userData.whatsappNumber,
//               verified: true
//             }
//           };
//         }
        
//         console.log('WhatsApp verified in Redux:', state.userData);
//       })
//       .addCase(verifyWhatsAppOTP.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload?.message || 'WhatsApp OTP verification failed';
//         state.whatsappVerified = false;
//       });
//   },
// });

// export const {
//   setRegistrationEmail,
//   setRegistrationStep,
//   resetRegistrationFlow,
//   logout,
//   clearError,
//   updateUserData,
//   setWhatsAppOtpSent,
//   setWhatsAppVerified,
//   clearWhatsAppStates,
// } = registerSlice.actions;

// // Export helper functions
// export { 
//   getRegistrationStatusText, 
//   isProfileCompleted, 
//   canProceedToNextStage, 
//   isApproved, 
//   isRejected 
// };

// export default registerSlice.reducer;


import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosClient } from '../../utils/auth.util.js';
import axios from 'axios';

// Token management utilities for register system
const saveRegisterTokenToLocalStorage = (token) => {
  if (token) {
    localStorage.setItem('registerToken', token);
  }
};

const removeRegisterTokenFromLocalStorage = () => {
  localStorage.removeItem('registerToken');
};

const getRegisterTokenFromLocalStorage = () => {
  return localStorage.getItem('registerToken');
};

// Update axios client for register token
const registerAxiosClient = axios.create({
  ...axiosClient.defaults,
});

// Add interceptor for register token
registerAxiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('registerToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Registration Status Constants (matching backend)
export const REGISTRATION_STATUS = {
  REJECTED: -1,
  EMAIL_VERIFIED: 1,
  PROFILE_COMPLETED: 2,
  INTERVIEW_REQUESTED_OR_SCREENING_COMPLETED: 3,
  APPROVED: 4
};

// Initial state
const initialState = {
  userData: null,
  authToken: getRegisterTokenFromLocalStorage(),
  submittedEmail: '',
  isOtpSent: false,
  registrationFlow: {
    step: 'email_input',
    userType: null,
    email: '',
    isOtpSent: false,
    nextAction: null,
  },
  isLoggedIn: !!getRegisterTokenFromLocalStorage(),
  isLoading: false,
  error: null,
  whatsappOtpSent: false,
  whatsappVerified: false,
};

// Async thunks for Onboarding Process
export const sendOnboardingOTP = createAsyncThunk(
  'register/sendOnboardingOTP',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/pendingexpert/send-otp/pendingexpert', { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to send OTP' });
    }
  }
);

export const verifyOnboardingOTP = createAsyncThunk(
  'register/verifyOnboardingOTP',
  async ({ email, otp_entered }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/pendingexpert/login/pendingexpert', {
        email,
        otp_entered
      });

      if (response.data.result?.token) {
        saveRegisterTokenToLocalStorage(response.data.result.token);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'OTP verification failed' });
    }
  }
);

export const verifyUser = createAsyncThunk(
  'register/verifyUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await registerAxiosClient.post('/pendingexpert/verify-user/pendingexpert');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'User verification failed' });
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'register/updateUserProfile',
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await registerAxiosClient.put('/pendingexpert/update-profile', profileData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Profile update failed' });
    }
  }
);

export const scheduleInterview = createAsyncThunk(
  'register/scheduleInterview',
  async (interviewData, { rejectWithValue }) => {
    try {
      const response = await registerAxiosClient.post('/pendingexpert/schedule-meeting', interviewData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Interview scheduling failed' });
    }
  }
);

// WhatsApp verification actions
export const sendWhatsAppOTP = createAsyncThunk(
  'register/sendWhatsAppOTP',
  async ({ name, whatsappNumber }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const userId = state.register.userData?.email?.replace(/[@.]/g, '_') || `USER_${Date.now()}`;
      
      const response = await axios.post(
        'https://testapis4.el.r.appspot.com/api/tutorWeb/sendVerificationOtp',
        {
          name: name.trim(),
          wa_id: whatsappNumber.trim(),
          tutorId: userId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000,
        }
      );
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to send WhatsApp OTP' });
    }
  }
);

export const verifyWhatsAppOTP = createAsyncThunk(
  'register/verifyWhatsAppOTP',
  async ({ otp }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const userId = state.register.userData?.email?.replace(/[@.]/g, '_') || `USER_${Date.now()}`;
      
      const response = await axios.post(
        'https://testapis4.el.r.appspot.com/api/tutorWeb/verifyOtp',
        {
          tutorId: userId,
          code: otp.trim(),
        }
      );
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'WhatsApp OTP verification failed' });
    }
  }
);

// Helper functions
const getRegistrationStatusText = (status, expertiseDomain) => {
  const statusMap = {
    [-1]: 'Rejected',
    [1]: 'Email Verified',
    [2]: 'Profile Completed',
    [3]: expertiseDomain === 'Music Tutor' ? 'Interview Requested' : 'Screening Completed',
    [4]: 'Approved'
  };
  return statusMap[status] || 'Unknown';
};

const isProfileCompleted = (status) => status >= REGISTRATION_STATUS.PROFILE_COMPLETED;
const canProceedToNextStage = (status) => status > 0 && status < REGISTRATION_STATUS.APPROVED;
const isApproved = (status) => status === REGISTRATION_STATUS.APPROVED;
const isRejected = (status) => status === REGISTRATION_STATUS.REJECTED;

// Redux slice
const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    setRegistrationEmail: (state, action) => {
      state.submittedEmail = action.payload;
      state.registrationFlow.email = action.payload;
    },
    
    setRegistrationStep: (state, action) => {
      state.registrationFlow.step = action.payload;
    },
    
    resetRegistrationFlow: (state) => {
      state.submittedEmail = '';
      state.isOtpSent = false;
      state.registrationFlow = {
        step: 'email_input',
        userType: null,
        email: '',
        isOtpSent: false,
        nextAction: null,
      };
      state.error = null;
    },
    
    logout: (state) => {
      Object.assign(state, {
        userData: null,
        authToken: null,
        submittedEmail: '',
        isOtpSent: false,
        registrationFlow: {
          step: 'email_input',
          userType: null,
          email: '',
          isOtpSent: false,
          nextAction: null,
        },
        isLoggedIn: false,
        error: null,
      });
      removeRegisterTokenFromLocalStorage();
    },
    
    clearError: (state) => {
      state.error = null;
    },

    updateUserData: (state, action) => {
      if (state.userData) {
        state.userData = { ...state.userData, ...action.payload };
      }
    },

    setWhatsAppOtpSent: (state, action) => {
      state.whatsappOtpSent = action.payload;
    },

    setWhatsAppVerified: (state, action) => {
      state.whatsappVerified = action.payload;
    },

    clearWhatsAppStates: (state) => {
      state.whatsappOtpSent = false;
      state.whatsappVerified = false;
    },

    // New exam-related reducers
    updateExamData: (state, action) => {
      const { examResult, subject, tutStatus } = action.payload;
      
      if (state.userData) {
        state.userData = {
          ...state.userData,
          tutStatus: tutStatus,
          tags: [...(state.userData.tags || []), subject],
          tutor_exam: [...(state.userData.tutor_exam || []), examResult],
        };
      }
    },
    
    updateTutorStatus: (state, action) => {
      if (state.userData) {
        state.userData = {
          ...state.userData,
          tutStatus: action.payload,
        };
      }
    },
    
    setTestResults: (state, action) => {
      if (state.userData) {
        state.userData = {
          ...state.userData,
          testResults: action.payload,
          testCompleted: true,
        };
      }
    },
    
    addExamResult: (state, action) => {
      if (state.userData) {
        state.userData = {
          ...state.userData,
          tutor_exam: [...(state.userData.tutor_exam || []), action.payload],
        };
      }
    },

    setCurrentExam: (state, action) => {
      if (state.userData) {
        state.userData = {
          ...state.userData,
          currentExam: action.payload,
        };
      }
    },
  },
  
  extraReducers: (builder) => {
    // Send onboarding OTP
    builder
      .addCase(sendOnboardingOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendOnboardingOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isOtpSent = true;
        state.registrationFlow.isOtpSent = true;
        state.registrationFlow.step = 'otp_verification';
      })
      .addCase(sendOnboardingOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Failed to send OTP';
      });

    // Verify onboarding OTP
    builder
      .addCase(verifyOnboardingOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyOnboardingOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoggedIn = true;
        state.authToken = action.payload.token;
        state.userData = action.payload.result;
        state.registrationFlow.step = 'complete';
      })
      .addCase(verifyOnboardingOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'OTP verification failed';
      });

    // Verify user
    builder
      .addCase(verifyUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userData = action.payload.result?.expert;
      })
      .addCase(verifyUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'User verification failed';
        
        if (action.payload?.message?.includes('token') || action.payload?.message?.includes('Unauthorized')) {
          state.userData = null;
          state.authToken = null;
          state.isLoggedIn = false;
          removeRegisterTokenFromLocalStorage();
        }
      });

    // Update user profile
    builder
      .addCase(updateUserProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        
        // Update userData with the complete response
        const updatedData = action.payload.result;
        state.userData = updatedData; // Store the complete updated expert data
        
        // If WhatsApp verification was updated, update the whatsappVerified state
        if (updatedData.whatsappNumber?.verified !== undefined) {
          state.whatsappVerified = updatedData.whatsappNumber.verified;
        }
        
        console.log('Profile updated in Redux:', {
          userData: state.userData,
          registrationStatus: state.userData.registrationStatus,
          whatsappVerified: state.whatsappVerified
        });
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Profile update failed';
      });

    // Schedule interview
    builder
      .addCase(scheduleInterview.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(scheduleInterview.fulfilled, (state, action) => {
        state.isLoading = false;
        
        // Update userData with interview information from backend response
        const result = action.payload.result;
        if (result?.expert) {
          state.userData = { 
            ...state.userData, 
            ...result.expert,
            interviewScheduled: true,
            interviewStatus: 'scheduled'
          };
        }
      })
      .addCase(scheduleInterview.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Interview scheduling failed';
      });

    // Send WhatsApp OTP
    builder
      .addCase(sendWhatsAppOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendWhatsAppOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.whatsappOtpSent = true;
      })
      .addCase(sendWhatsAppOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Failed to send WhatsApp OTP';
        state.whatsappOtpSent = false;
      });

    // Verify WhatsApp OTP
    builder
      .addCase(verifyWhatsAppOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyWhatsAppOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.whatsappVerified = true;
        state.whatsappOtpSent = false;
        
        // Also update userData to reflect WhatsApp verification
        if (state.userData) {
          state.userData = {
            ...state.userData,
            whatsappNumber: {
              ...state.userData.whatsappNumber,
              verified: true
            }
          };
        }
        
        console.log('WhatsApp verified in Redux:', state.userData);
      })
      .addCase(verifyWhatsAppOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'WhatsApp OTP verification failed';
        state.whatsappVerified = false;
      });
  },
});

export const {
  setRegistrationEmail,
  setRegistrationStep,
  resetRegistrationFlow,
  logout,
  clearError,
  updateUserData,
  setWhatsAppOtpSent,
  setWhatsAppVerified,
  clearWhatsAppStates,
  updateExamData,
  updateTutorStatus,
  setTestResults,
  addExamResult,
  setCurrentExam,
} = registerSlice.actions;

// Export helper functions
export { 
  getRegistrationStatusText, 
  isProfileCompleted, 
  canProceedToNextStage, 
  isApproved, 
  isRejected 
};

export default registerSlice.reducer;
